import { z } from 'zod';
import { freetextInput } from './freetext/input.freetext.js';
import { groupTileInput } from './group/input.tile.js';
import { matchDropzoneInput } from './match/input.dropzone.js';
export { audioDropzoneSchema, imageDropzoneSchema, textDropzoneSchema } from './match/input.dropzone.js';
import { inTextDropzoneInput } from './place-items.in-text/input.dropzone.js';
import { onImageDropzoneInput } from './place-items.on-image/input.dropzone.js';
import { transparentImageOnImageDropzoneInput } from './place-items.transparent-image-on-image/input.dropzone.js';
import { dropdownInput } from './select-answers-dropdown/input.dropdown.js';
import { wordDropdownInput } from './select-answers-dropdown/input.word-dropdown.js';
import { checkboxMediaInput } from './select-answers.checkbox/input.media.js';
export { selectAnswersMediaInputSchema } from './select-answers.checkbox/input.media.js';
import { hyphenatableWordInput } from './select-answers.hyphenate-words/input.hyphenatable-word.js';
import { selectableCharacterInput } from './select-answers.mark-characters/input.selectable-character.js';
import { selectableWordInput } from './select-answers.mark-words/input.selectable-word.js';
import { poolCouponRowInput } from './select-answers.pool-coupon/input.row.js';
import { radioButtonMediaInput } from './select-answers.radio-button/input.media.js';
import { sentenceInput } from './sequence.sentence/input.sentence.js';
import { sequenceTileInput } from './sequence.sequence/input.tile.js';
import { textCorrectionInput } from './text-correction/input.text-correction.js';
import { inTableCheckboxInput } from './write-answers.in-table/input.checkbox.js';
import { inTableFractionInput } from './write-answers.in-table/input.fraction.js';
import { inTableTextInput } from './write-answers.in-table/input.text.js';
import { fractionInput } from './write-answers.in-text/input.fraction.js';
import { textInput } from './write-answers.in-text/input.text.js';
import { onImageFractionInput } from './write-answers.on-image/input.fraction.js';
import { onImageTextInput } from './write-answers.on-image/input.text.js';

const opgavekompleksetInputEntrySchema = z.discriminatedUnion("type", [checkboxMediaInput.entry.schema, dropdownInput.entry.schema, fractionInput.entry.schema, freetextInput.entry.schema, groupTileInput.entry.schema, hyphenatableWordInput.entry.schema, inTableCheckboxInput.entry.schema, inTableFractionInput.entry.schema, inTableTextInput.entry.schema, inTextDropzoneInput.entry.schema, matchDropzoneInput.entry.schema, onImageDropzoneInput.entry.schema, onImageFractionInput.entry.schema, onImageTextInput.entry.schema, poolCouponRowInput.entry.schema, radioButtonMediaInput.entry.schema, selectableCharacterInput.entry.schema, selectableWordInput.entry.schema, sentenceInput.entry.schema, sequenceTileInput.entry.schema, textCorrectionInput.entry.schema, textInput.entry.schema, transparentImageOnImageDropzoneInput.entry.schema, wordDropdownInput.entry.schema]);
const IGNORED_NODES = ["html", "text", "inline-audio", "video-23", "audio", "mark-words-whitespace", "mark-characters-whitespace", "in-table-image", "in-table-readonly", "on-image-readonly"];
function validateOpgavekompleksetInput(node, entry, context) {
  if (!entry) {
    return false;
  }
  switch (true) {
    case IGNORED_NODES.includes(node.nodeType):
      return false;
    case node.nodeType === "text-input" && entry.type === "text":
      return textInput.entry.validate(node, entry, context);
    case node.nodeType === "fraction-input" && entry.type === "fraction":
      return fractionInput.entry.validate(node, entry);
    case node.nodeType === "dropdown-input" && entry.type === "dropdown":
      return dropdownInput.entry.validate(node, entry);
    case node.nodeType === "word-dropdown-input" && entry.type === "word-dropdown":
      return wordDropdownInput.entry.validate(node, entry);
    case node.nodeType === "media-input" && entry.type === "checkbox-media":
      return checkboxMediaInput.entry.validate(node, entry);
    case node.nodeType === "media-input" && entry.type === "radio-button-media":
      return radioButtonMediaInput.entry.validate(node, entry);
    case node.nodeType === "sentence-input" && entry.type === "sentence":
      return sentenceInput.entry.validate(node, entry);
    case node.nodeType === "sequence-tile-input" && entry.type === "sequence-tile":
      return sequenceTileInput.entry.validate(node, entry);
    case node.nodeType === "group-tile-input" && entry.type === "group-tile":
      return groupTileInput.entry.validate(node, entry);
    case node.nodeType === "match-dropzone-input" && entry.type === "match-dropzone":
      return matchDropzoneInput.entry.validate(node, entry);
    case node.nodeType === "selectable-word-input" && entry.type === "selectable-word":
      return selectableWordInput.entry.validate(node, entry);
    case node.nodeType === "selectable-character-input" && entry.type === "selectable-character":
      return selectableCharacterInput.entry.validate(node, entry);
    case node.nodeType === "hyphenatable-word-input" && entry.type === "hyphenatable-word":
      return hyphenatableWordInput.entry.validate(node, entry);
    case node.nodeType === "text-correction-input" && entry.type === "text-correction":
      return textCorrectionInput.entry.validate(node, entry);
    case node.nodeType === "freetext-input" && entry.type === "freetext":
      return freetextInput.entry.validate();
    case node.nodeType === "pool-coupon-row-input" && entry.type === "pool-coupon-row":
      return poolCouponRowInput.entry.validate(node, entry);
    case node.nodeType === "in-table-checkbox-input" && entry.type === "in-table-checkbox":
      return inTableCheckboxInput.entry.validate(node, entry);
    case node.nodeType === "in-table-text-input" && entry.type === "in-table-text":
      return inTableTextInput.entry.validate(node, entry, context);
    case node.nodeType === "in-table-fraction-input" && entry.type === "in-table-fraction":
      return inTableFractionInput.entry.validate(node, entry);
    case node.nodeType === "on-image-fraction-input" && entry.type === "on-image-fraction":
      return onImageFractionInput.entry.validate(node, entry);
    case node.nodeType === "on-image-text-input" && entry.type === "on-image-text":
      return onImageTextInput.entry.validate(node, entry, context);
    case node.nodeType === "in-text-dropzone-input" && entry.type === "in-text-dropzone":
      return inTextDropzoneInput.entry.validate(node, entry);
    case node.nodeType === "on-image-dropzone-input" && entry.type === "on-image-dropzone":
      return onImageDropzoneInput.entry.validate(node, entry);
    case node.nodeType === "transparent-image-on-image-dropzone-input" && entry.type === "transparent-image-on-image-dropzone":
      return transparentImageOnImageDropzoneInput.entry.validate(node, entry);
    default:
      console.warn("validateInput(): Encountered unrecognized node and entry pair", {
        node,
        entry: JSON.parse(JSON.stringify(entry))
      });
      return false;
  }
}
function shouldValidateOpgavekompleksetInput(node, entry) {
  if (IGNORED_NODES.includes(node.nodeType)) {
    return false;
  }
  if (node.nodeType === "text-input" && (!entry || entry.type === "text")) {
    return textInput.entry.shouldValidate(node);
  }
  if (node.nodeType === "fraction-input" && (!entry || entry.type === "fraction")) {
    return fractionInput.entry.shouldValidate(node);
  }
  if (node.nodeType === "dropdown-input" && (!entry || entry.type === "dropdown")) {
    return dropdownInput.entry.shouldValidate(node, entry);
  }
  if (node.nodeType === "word-dropdown-input" && (!entry || entry.type === "word-dropdown")) {
    return wordDropdownInput.entry.shouldValidate(node, entry);
  }
  if (node.nodeType === "media-input" && (!entry || entry.type === "checkbox-media")) {
    return checkboxMediaInput.entry.shouldValidate(node, entry);
  }
  if (node.nodeType === "media-input" && (!entry || entry.type === "radio-button-media")) {
    return radioButtonMediaInput.entry.shouldValidate(node);
  }
  if (node.nodeType === "sentence-input" && (!entry || entry.type === "sentence")) {
    return sentenceInput.entry.shouldValidate(node);
  }
  if (node.nodeType === "sequence-tile-input" && (!entry || entry.type === "sequence-tile")) {
    return sequenceTileInput.entry.shouldValidate(node);
  }
  if (node.nodeType === "group-tile-input" && (!entry || entry.type === "group-tile")) {
    return groupTileInput.entry.shouldValidate(node, entry);
  }
  if (node.nodeType === "match-dropzone-input" && (!entry || entry.type === "match-dropzone")) {
    return matchDropzoneInput.entry.shouldValidate(node);
  }
  if (node.nodeType === "selectable-word-input" && (!entry || entry.type === "selectable-word")) {
    return selectableWordInput.entry.shouldValidate(node, entry);
  }
  if (node.nodeType === "selectable-character-input" && (!entry || entry.type === "selectable-character")) {
    return selectableCharacterInput.entry.shouldValidate(node, entry);
  }
  if (node.nodeType === "hyphenatable-word-input" && (!entry || entry.type === "hyphenatable-word")) {
    return hyphenatableWordInput.entry.shouldValidate(node);
  }
  if (node.nodeType === "text-correction-input" && (!entry || entry.type === "text-correction")) {
    return textCorrectionInput.entry.shouldValidate(node);
  }
  if (node.nodeType === "freetext-input" && (!entry || entry.type === "freetext")) {
    return freetextInput.entry.shouldValidate();
  }
  if (node.nodeType === "pool-coupon-row-input" && (!entry || entry.type === "pool-coupon-row")) {
    return poolCouponRowInput.entry.shouldValidate();
  }
  if (node.nodeType === "in-table-checkbox-input" && (!entry || entry.type === "in-table-checkbox")) {
    return inTableCheckboxInput.entry.shouldValidate(node, entry);
  }
  if (node.nodeType === "in-table-fraction-input" && (!entry || entry.type === "in-table-fraction")) {
    return inTableFractionInput.entry.shouldValidate(node);
  }
  if (node.nodeType === "in-table-text-input" && (!entry || entry.type === "in-table-text")) {
    return inTableTextInput.entry.shouldValidate(node);
  }
  if (node.nodeType === "on-image-fraction-input" && (!entry || entry.type === "on-image-fraction")) {
    return onImageFractionInput.entry.shouldValidate(node);
  }
  if (node.nodeType === "on-image-text-input" && (!entry || entry.type === "on-image-text")) {
    return onImageTextInput.entry.shouldValidate(node);
  }
  if (node.nodeType === "in-text-dropzone-input" && (!entry || entry.type === "in-text-dropzone")) {
    return inTextDropzoneInput.entry.shouldValidate(node);
  }
  if (node.nodeType === "on-image-dropzone-input" && (!entry || entry.type === "on-image-dropzone")) {
    return onImageDropzoneInput.entry.shouldValidate(node);
  }
  if (node.nodeType === "transparent-image-on-image-dropzone-input" && (!entry || entry.type === "transparent-image-on-image-dropzone")) {
    return transparentImageOnImageDropzoneInput.entry.shouldValidate(node);
  }
  console.warn("shouldValidateOpgavekompleksetInput(): Encountered unrecognized node and entry pair", {
    node,
    entry: JSON.parse(JSON.stringify(entry))
  });
  return false;
}
function isIgnoredOpgavekompleksetInputNode(node) {
  return IGNORED_NODES.includes(node.nodeType);
}
function parseLegacyDetailItem(item, context) {
  return textInput.entry.parseLegacyDetailItem(item, context) || checkboxMediaInput.entry.parseLegacyDetailItem(item, context) || radioButtonMediaInput.entry.parseLegacyDetailItem(item, context) || dropdownInput.entry.parseLegacyDetailItem(item, context) || wordDropdownInput.entry.parseLegacyDetailItem(item, context) || fractionInput.entry.parseLegacyDetailItem(item, context) || sentenceInput.entry.parseLegacyDetailItem(item, context) || sequenceTileInput.entry.parseLegacyDetailItem(item, context) || groupTileInput.entry.parseLegacyDetailItem(item, context) || matchDropzoneInput.entry.parseLegacyDetailItem(item, context) || selectableWordInput.entry.parseLegacyDetailItem(item, context) || selectableCharacterInput.entry.parseLegacyDetailItem(item, context) || hyphenatableWordInput.entry.parseLegacyDetailItem(item, context) || textCorrectionInput.entry.parseLegacyDetailItem(item, context) || freetextInput.entry.parseLegacyDetailItem(item, context) || poolCouponRowInput.entry.parseLegacyDetailItem(item, context) || inTextDropzoneInput.entry.parseLegacyDetailItem(item, context) || inTableCheckboxInput.entry.parseLegacyDetailItem(item, context) || inTableFractionInput.entry.parseLegacyDetailItem(item, context) || inTableTextInput.entry.parseLegacyDetailItem(item, context) || onImageDropzoneInput.entry.parseLegacyDetailItem(item, context) || onImageTextInput.entry.parseLegacyDetailItem(item, context) || onImageFractionInput.entry.parseLegacyDetailItem(item, context);
}

export { checkboxMediaInput, dropdownInput, fractionInput, freetextInput, groupTileInput, hyphenatableWordInput, inTableCheckboxInput, inTableFractionInput, inTableTextInput, inTextDropzoneInput, isIgnoredOpgavekompleksetInputNode, matchDropzoneInput, onImageDropzoneInput, onImageFractionInput, onImageTextInput, opgavekompleksetInputEntrySchema, parseLegacyDetailItem, poolCouponRowInput, radioButtonMediaInput, selectableCharacterInput, selectableWordInput, sentenceInput, sequenceTileInput, shouldValidateOpgavekompleksetInput, textCorrectionInput, textInput, transparentImageOnImageDropzoneInput, validateOpgavekompleksetInput, wordDropdownInput };
//# sourceMappingURL=_inputs.js.map
